import { useSyncExternalStore } from "react";
import "altcha";
import type {} from "altcha/types/react";

const CHALLENGE_URL = `${import.meta.env.VITE_API_URL}/api/v1/captcha/challenge`;

/**
 * Renders the `<altcha-widget>` web component.
 *
 * When `hasActiveToken` is true the widget collapses to zero height so it stays
 * mounted (keeping its internal state) but doesn't take visual space.
 */
export function AltchaWidget({
	widgetRef,
	hasActiveToken = false,
}: {
	widgetRef: React.Ref<HTMLElement>;
	hasActiveToken?: boolean;
}) {
	const isClient = useSyncExternalStore(
		() => () => {},
		() => true,
		() => false,
	);

	if (!isClient) return <span>Loading...</span>;

	return (
		<div
			className={
				hasActiveToken
					? "w-full h-0 invisible overflow-hidden"
					: "w-full min-h-0 flex items-center justify-center"
			}
		>
			<altcha-widget
				ref={widgetRef}
				challenge={CHALLENGE_URL}
				display="invisible"
				style={{ width: "100%" }}
			/>
		</div>
	);
}
